'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CallingSuspension from './CallingSuspension';
import { getAsyncAccountVerificationStatus, getAsyncCallingAccessScopesStatus, getShouldBlockCalling } from '../operators/callingAccessGetters';
import { UNINITIALIZED } from 'calling-lifecycle-internal/universal-calling-store/constants/asyncStatuses';
import { jsx as _jsx } from "react/jsx-runtime";
class EnsureCallingAccess extends PureComponent {
  render() {
    const {
      children,
      appIdentifier,
      useFullWidth = true,
      LoadingComponent,
      scopes,
      isThirdPartyProvider,
      callingAccess
    } = this.props;
    const asyncCallingAccessVerificationState = getAsyncAccountVerificationStatus(callingAccess);
    const asyncCallingAccessScopesState = getAsyncCallingAccessScopesStatus(callingAccess);
    if (asyncCallingAccessVerificationState === UNINITIALIZED || asyncCallingAccessScopesState === UNINITIALIZED) {
      return LoadingComponent ? /*#__PURE__*/_jsx(LoadingComponent, {
        isThirdPartyProvider: isThirdPartyProvider
      }) : /*#__PURE__*/_jsx("div", {
        "data-selenium-test": "ensure-calling-access-default-loader"
      });
    }
    if (getShouldBlockCalling(callingAccess)) {
      return /*#__PURE__*/_jsx(CallingSuspension, {
        callingAccess: callingAccess,
        useFullWidth: useFullWidth,
        appIdentifier: appIdentifier,
        scopes: scopes
      });
    }
    return children;
  }
}
EnsureCallingAccess.propTypes = {
  appIdentifier: PropTypes.string.isRequired,
  children: PropTypes.node,
  useFullWidth: PropTypes.bool,
  callingAccess: PropTypes.object.isRequired,
  LoadingComponent: PropTypes.object,
  scopes: PropTypes.object.isRequired,
  isThirdPartyProvider: PropTypes.bool
};
EnsureCallingAccess.defaultProps = {
  isThirdPartyProvider: false
};
export default EnsureCallingAccess;